<!--
Author: TangChen
Date: 2018-10-08
Desc: 手机号码绑定，由index.js 配置引入
 -->
<template>
    <div v-if="showEmailComp">
        <div class="bizcomp-check-email">
            <my-dialog
                class="my-dialog-contain"
                title="修改电子邮箱"
                :visible="visible"
                width="620px"
                :dialog-close="checkDialogClose"
            >
                <div v-if="!resultSuccess" class="acct-con">
                    <div class="check-acct">
                        <el-form
                            ref="pwdForm"
                            :model="pwdForm"
                            :rules="rules"
                            inline-message
                            v-on:submit.native.prevent
                        >
                            <el-form-item prop="email" label="电子邮箱:" class="form-text">
                                <el-input
                                    v-model.trim="pwdForm.email"
                                    class="input-mobile"
                                    placeholder="请输入电子邮箱号码"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="邮箱验证码:"
                                prop="verifyCode"
                                class="verifycode-row"
                            >
                                <el-input
                                    v-model.trim="pwdForm.verifyCode"
                                    class="verifycode-style"
                                    placeholder="请输入验证码"
                                    :maxlength="6"
                                ></el-input>
                                <span class="get-verify" :disabled="time > 0" v-on:click="sendCode">
                                    {{ btnMsg }}
                                </span>
                            </el-form-item>
                            <!-- <el-form-item
                                prop="pwd"
                                label="交易密码:"
                                class="form-text"
                            >
                                <el-input
                                    v-model.trim="pwdForm.pwd"
                                    type="password"
                                    placeholder="请输入交易密码"
                                    class="input-pwd"
                                    :maxlength="6"
                                />
                            </el-form-item> -->

                            <el-form-item>
                                <div class="btn-contain">
                                    <!-- <button
                                        class="cancel-btn"
                                        v-on:click="checkDialogClose"
                                    >
                                        取消
                                    </button> -->
                                    <button class="confirm-btn" v-on:click="submitForm('pwdForm')">
                                        确定
                                    </button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div v-else class="change-email-result">
                    <div class="result-contain">
                        <div class="result-img-contain">
                            <img src="../../assets/img/success.png" alt="" />
                        </div>
                        <div class="result-text">修改电子邮箱成功!</div>
                    </div>
                    <div class="result-confirm-contain">
                        <button class="result-confirm" v-on:click="checkDialogClose">确定</button>
                    </div>
                </div>
            </my-dialog>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
// import imgCode from "@/components/layout/imgCode.vue";
import userApi from "@/api/user";
import myDialog from "@/components/layout/myDialog.vue";

export default {
    name: "CheckAcct",
    components: {
        // imgCode,
        myDialog
    },
    mixins: [mixin],
    props: {
        showEmailComp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: true,
            resultSuccess: false,
            time: 0, // 验证码再次发送间隔
            pwdForm: {
                // 表单参数配置
                email: "",
                verifyCode: ""
                // pwd: "", // 修改用户信息界面不支持校验交易密码，所以这里修改邮箱也不支持
            },
            btnMsg: "获取验证码",
            locked: false, // 是否已发送短信验证码
            rules: {
                // 校验规则
                email: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                verifyCode: [
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ]
                // pwd: [
                //     {
                //         required: true,
                //         message: "请输入交易密码",
                //         trigger: "blur",
                //     },
                // ],
            }
        };
    },
    watch: {
        showEmailComp(value) {
            this.visible = value;
        }
    },
    created() {
        this.time = 0;
    },

    methods: {
        checkDialogClose() {
            this.visible = false;
            this.resultSuccess = false;
            this.pwdForm.email = "";
            this.pwdForm.verifyCode = "";
            // this.pwdForm.pwd = "";
            if (this.locked) {
                this.time = 1;
                this.locked = false;
            }
            this.$emit("dialog-close", false);
        },
        /* 提交表单数据,校验邮箱验证码 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.locked) {
                        this.$message({
                            type: "warning",
                            message: "请先发送邮箱验证码"
                        });
                        return false;
                    }
                    this.checkVerifyCode();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 获取验证码
        sendCode() {
            if (this.time > 0) return;
            for (const key in this.pwdForm) {
                if (key == "email") {
                    this.$refs["pwdForm"].validateField(key, async (str) => {
                        if (str) {
                            return false;
                        } else {
                            const res = await userApi.sendEmail({
                                email: this.pwdForm.email,
                                biztype: "0"
                            });
                            if (res.data) {
                                this.time = res.data.sendperiod;
                                this.locked = true;
                                this.$util.btnDisabled(this);
                            }
                        }
                    });
                }
            }
        },
        /* 校验邮箱验证码 */
        async checkVerifyCode() {
            const res = await userApi.checkEmailCode({
                emailcode: this.pwdForm.verifyCode,
                biztype: "0"
            });
            if (res.code === "0") {
                const modRes = await userApi.modifyEmail({
                    email: this.pwdForm.email
                    // tradepassword: this.pwdForm.pwd,
                });
                if (modRes.code === "0") {
                    this.resultSuccess = true;
                    this.$cache.refreshUser();
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-check-email {
    .acct-con {
        padding: 40px 40px 20px;
        :deep(.el-form-item) {
            margin: 0;
        }
        :deep(.el-form-item__error--inline) {
            margin-left: 90px;
        }
        :deep(.el-form-item__label) {
            width: 85px;
            text-align: right;
            padding: 0;
        }
        .form-text {
            .input-mobile {
                margin-left: 10px;
                width: 416px;
            }
            .input-pwd {
                margin-left: 10px;
                width: 416px;
            }
        }
        .verifycode-row {
            margin: 23px 0;
            font-size: 14px;
            font-weight: normal;
            color: #333333;
            .verifycode-style {
                margin-left: 10px;
                position: relative;
                width: 416px;
                border-radius: 2px;
                background: #ffffff;
                box-sizing: border-box;
                border: 1px solid #d9d9d9;
            }
            .get-verify {
                position: absolute;
                right: 50px;
                font-size: 16px;
                font-weight: normal;
                cursor: pointer;
                color: #e60012;
            }
        }

        .btn-contain {
            text-align: center;
            margin-top: 30px;
            .cancel-btn {
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                color: #666666;
                border: 1px solid #e4e4e4;
                cursor: pointer;
            }
            .confirm-btn {
                margin-left: 40px;
                padding: 10px 0;
                width: 180px;
                border-radius: 2px;
                background: #e60012;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                border: 1px solid #e60012;
                cursor: pointer;
            }
        }
    }
    .change-email-result {
        text-align: center;
        .result-text {
            font-size: 26px;
            margin-top: 24px;
            font-weight: 500;
            color: #333333;
        }
    }
    .result-contain {
        width: 590px;
        margin: auto;
        margin-top: 40px;
        background: hsl(0, 0%, 98%);
        height: 242px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .result-confirm-contain {
        text-align: center;
        margin-top: 30px;
        .result-confirm {
            cursor: pointer;
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e60012;
            border: 1px solid #e60012;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
    .margin-10 {
        margin: 10px 0;
    }
    .color-e60012 {
        color: #e60012;
    }
}
</style>
